// frontend/src/lib/coworker-count.ts
//
// The roster size as a word, so a sentence about "your coworkers" never says a
// number the roster no longer has (seven on the six-stage lifecycle).

import { COWORKERS } from './coworkers'

const WORDS = ['no', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten']

export function coworkerCountWord(count: number = COWORKERS.length): string {
  return count >= 0 && count < WORDS.length ? WORDS[count] : String(count)
}
